<template>
  <a-table
    size="small"
    :columns="columns"
    :data-source="bookmarks"
    :scroll="{ y: 380 }"
    :pagination="{
      pageSizeOptions: ['10', '50'],
      pageSize: 50,
      current: 1,
      total: bookmarks.length,
      showSizeChanger: true
    }"
    row-key="id"
  >
    <template slot="is_favorite" slot-scope="text, record">
      <span @click="onCellChange(record, 'is_favorite', !record.is_favorite)">
        <a-icon
          :icon="record.is_favorite ? 'carbon:star-filled' : 'carbon:star'"
          width="20px"
          height="20px"
          class="star"
          :style="{
            color: record.is_favorite ? 'var(--warning-color)' : ''
          }"
      /></span>
    </template>
    <template slot="name" slot-scope="text, record">
      <editable-cell :text="text" @change="onCellChange(record, 'name', $event)" />
    </template>
    <template slot="url" slot-scope="text, record">
      <editable-cell :text="text" @change="onCellChange(record, 'url', $event)" />
    </template>
    <span slot="actions" slot-scope="text, record" class="flex gap-2"
      ><span @click="handleOpenBookmark(record.url)">
        <a-icon icon="carbon:jump-link" width="20px" height="20px" class="open"
      /></span>
      <span @click="handleDelete(record.id)">
        <a-icon icon="carbon:trash-can" width="20px" height="20px" class="trash"
      /></span>
    </span>
  </a-table>
</template>

<script>
import { notification, Table } from 'ant-design-vue'
import { createNamespacedHelpers } from 'vuex'
import TableEditableCell from '../entities/table/table-editable-cell.vue'

const { mapActions: bookmarksAction, mapState: bookmarksState } = createNamespacedHelpers('bookmarks')

export default {
  components: {
    'a-table': Table,
    'editable-cell': TableEditableCell
  },
  data() {
    return {
      pagination: {
        pageSizeOptions: ['10', '50', '100'],
        pageSize: 50,
        current: 1,
        total: 0,
        showSizeChanger: true
      },

      columns: [
        {
          title: '',
          dataIndex: 'is_favorite',
          width: 20,
          scopedSlots: { customRender: 'is_favorite' },
          key: 'is_favorite'
        },
        {
          title: 'Name',
          dataIndex: 'name',
          width: 200,
          scopedSlots: { customRender: 'name' },
          key: 'name'
        },
        {
          title: 'Link',
          dataIndex: 'url',
          width: 300,
          scopedSlots: { customRender: 'url' },
          key: 'url'
        },
        {
          title: '',
          width: 50,
          dataIndex: 'actions',
          scopedSlots: { customRender: 'actions' },
          key: 'actions'
        }
      ]
    }
  },
  computed: {
    ...bookmarksState({
      bookmarks: state => state.bookmarks
    })
  },
  methods: {
    ...bookmarksAction(['updateBookmark', 'deleteBookmark']),

    showNotification(type, message, description) {
      notification[type]({
        message,
        description
      })
    },

    handleOpenBookmark(url) {
      if (url.startsWith('http://') || url.startsWith('https://')) {
        window.location.href = url
      } else {
        this.$router.push(url).catch(() => {})
      }
    },

    async onCellChange(record, dataIndex, value) {
      if (typeof value === 'string' && value.trim() === record[dataIndex].trim()) {
        return
      }

      try {
        const payload = {
          bookmark: {
            ...record,
            [dataIndex]: typeof value === 'string' ? value.trim() : value
          }
        }

        await this.updateBookmark(payload)
      } catch (error) {
        this.showNotification('error', 'Error', typeof error === 'string' ? error : error?.message)
      }
    },

    async handleDelete(id) {
      try {
        await this.deleteBookmark({ id })
      } catch (error) {
        this.showNotification('error', 'Error', typeof error === 'string' ? error : error?.message)
      }
    },

    async editBookmark() {}
  }
}
</script>

<style scoped>
.star,
.open,
.trash {
  transition: 0.3s all ease-in-out;
  cursor: pointer;
}

.star:hover {
  color: var(--warning-color);
}

.open:hover {
  color: var(--primary-color);
}

.trash:hover {
  color: var(--error-color);
}
</style>
